import { useEffect } from 'react';

const disable = () => {
  document.body.style.overscrollBehavior = 'none';
  document.documentElement.style.overscrollBehavior = 'none';
};

const enable = () => {
  document.body.style.overscrollBehavior = 'unset';
  document.documentElement.style.overscrollBehavior = 'unset';
};

export const useOverscrollDisable = () => {
  useEffect(() => {
    disable();
    return () => {
      enable();
    };
  }, []);
};
